export const defaultState = () => {
    return {
        registrationId: null,
        hrId: null
    }
}

const state = defaultState()
export default state
